module.exports = __webpack_public_path__ + "img/companyIntro31.06737f28.png";